var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_5831",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.100098,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_5831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6001 18.9999V10.1537C4.6001 9.86752 4.66412 9.59638 4.79217 9.34029C4.92022 9.08421 5.09722 8.87332 5.32317 8.70762L11.0155 4.41917C11.3314 4.17813 11.6924 4.05762 12.0985 4.05762C12.5047 4.05762 12.8667 4.17813 13.1847 4.41917L18.877 8.70762C19.1029 8.87332 19.2799 9.08421 19.408 9.34029C19.536 9.59638 19.6 9.86752 19.6 10.1537V18.9999C19.6 19.4089 19.4523 19.7611 19.1568 20.0566C18.8613 20.3521 18.509 20.4999 18.1001 20.4999H14.9077C14.6517 20.4999 14.437 20.4132 14.2638 20.24C14.0905 20.0668 14.0039 19.8521 14.0039 19.596V14.7114C14.0039 14.4553 13.9173 14.2406 13.744 14.0674C13.5708 13.8942 13.3562 13.8076 13.1001 13.8076H11.1001C10.844 13.8076 10.6293 13.8942 10.4561 14.0674C10.2828 14.2406 10.1962 14.4553 10.1962 14.7114V19.596C10.1962 19.8521 10.1096 20.0668 9.93637 20.24C9.76314 20.4132 9.54848 20.4999 9.2924 20.4999H6.10007C5.69111 20.4999 5.33887 20.3521 5.04337 20.0566C4.74786 19.7611 4.6001 19.4089 4.6001 18.9999Z",
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGreen);
export default __webpack_public_path__ + "static/media/home_green.6c8b5a4e118ac65076c1626f00d29ff9.svg";
export { ForwardRef as ReactComponent };